import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

import { DailyContributionsEnum as Fields } from 'Common/FieldEnum';

import { formatAnalysisValue } from '../utilities';
import { VIEW_BY } from '../constants';

const DailyContributionsToShow = [
  Fields.DarkGreenVeg,
  Fields.RedOrangeVeg,
  Fields.LegumesVeg,
  Fields.StarchyVeg,
  Fields.OtherVeg,
  Fields.AdditionalVeg,
  Fields.Calories,
  Fields.SatFat,
  Fields.Sodium,
];

const DailyContributionsDescriptionMap = {
  [Fields.Calories]: 'Calories',
  [Fields.DarkGreenVeg]: 'Dark Green Veg.',
  [Fields.EnrichedGrain]: 'Enriched Grain',
  [Fields.Fruit]: 'Fruit',
  [Fields.FruitJuice]: 'Fruit Juice',
  [Fields.GrainDessert]: 'Grain Dessert',
  [Fields.LegumesVeg]: 'Beans, Peas, Lentils',
  [Fields.MeatAlt]: 'Meat/Meat Alt.',
  [Fields.Milk]: 'Milk',
  [Fields.Milk_2Varieties]: 'Milk 2 Varieties',
  [Fields.OtherVeg]: 'Other Veg.',
  [Fields.AdditionalVeg]: 'Additional Veg.',
  [Fields.RedOrangeVeg]: 'Red/Orange Veg.',
  [Fields.SatFat]: 'Saturated Fat',
  [Fields.Sodium]: 'Sodium',
  [Fields.StarchyVeg]: 'Starchy Veg.',
  [Fields.TotalGrain]: 'Total Grain',
  [Fields.TotalVeg]: 'Total Veg.',
  [Fields.VegJuice]: 'Veg. Juice',
  [Fields.WholeGrain]: 'Whole Grain',
};

const DailyContributions = ({ contributions, viewType }) =>
  DailyContributionsToShow.map((contribution) => {
    const description = DailyContributionsDescriptionMap[contribution];
    const value = Number(contributions[contribution]) || 0;
    if (value === 0) {
      return null;
    }

    let leftColWidth = 8;
    let rightColWidth = 8;

    switch (viewType) {
      case VIEW_BY.WEEK:
        leftColWidth = 4;
        rightColWidth = 12;
        break;
      case VIEW_BY.DAY:
        leftColWidth = 2;
        rightColWidth = 14;
        break;
      default:
        break;
    }

    return (
      <div key={description} className="daily-contribution">
        <Grid padded>
          <Grid.Row className="daily-contribution-item">
            <Grid.Column width={leftColWidth}>{description}</Grid.Column>
            <Grid.Column width={rightColWidth}>
              {formatAnalysisValue(value)}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  });

DailyContributions.propTypes = {
  contributions: PropTypes.shape({
    [Fields.DayNumber]: PropTypes.number,
    [Fields.Calories]: PropTypes.number,
    [Fields.DarkGreenVeg]: PropTypes.number,
    [Fields.AdditionalVeg]: PropTypes.number,
    [Fields.EnrichedGrain]: PropTypes.number,
    [Fields.Fruit]: PropTypes.number,
    [Fields.FruitJuice]: PropTypes.number,
    [Fields.GrainDessert]: PropTypes.number,
    [Fields.LegumesVeg]: PropTypes.number,
    [Fields.MeatAlt]: PropTypes.number,
    [Fields.Milk]: PropTypes.number,
    [Fields.Milk_2Varieties]: PropTypes.bool,
    [Fields.OtherVeg]: PropTypes.number,
    [Fields.RedOrangeVeg]: PropTypes.number,
    [Fields.SatFat]: PropTypes.number,
    [Fields.Sodium]: PropTypes.number,
    [Fields.StarchyVeg]: PropTypes.number,
    [Fields.TotalGrain]: PropTypes.number,
    [Fields.TotalVeg]: PropTypes.number,
    [Fields.VegJuice]: PropTypes.number,
    [Fields.WholeGrain]: PropTypes.number,
  }),
};

DailyContributions.defaultProps = {
  contributions: {},
  viewType: VIEW_BY.MONTH,
};

export { DailyContributions };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/DailyContributions.js